import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const formSelector = '.es-form';
	const formElements = document.querySelectorAll(formSelector);

	if (!formElements) {
		return;
	}

	const { UtmFirstSession } = await import('./utm-first-session');

	[...formElements].forEach((element) => {
		const utmFirstSession = new UtmFirstSession({
			element,
		});

		utmFirstSession.init();
	});
});
